import { useCallback, useEffect, useState } from 'react'

import { useFocusEffect } from '@react-navigation/native'
import { publishEvent } from '@zet/analytics'
import {
  CopilotProvider,
  CopilotStep,
  useCopilot,
  walkthroughable,
} from '@zet/common/components/coachMarks'
import { Stack } from '@zet/design-system'
import storageUtil from '@zet/utils/storage'

import { CUSTOMER_SOURCE } from '../addCustomerStates'

const CopilotStack = walkthroughable(Stack)

const useCoachMarks = ({
  source,
  isDemoSale,
}: {
  source: string
  isDemoSale: boolean
}) => {
  const customerAdditionSource = source
  const isComingFromTryDemoSell =
    customerAdditionSource === CUSTOMER_SOURCE.DEMO_SELL || isDemoSale
  const value = useCopilot()
  const [isLayoutRendered, setIsLayoutRendered] = useState(false)

  useFocusEffect(
    useCallback(() => {
      const isAddCustomerCoachmarkShown = storageUtil.getObject(
        'addCustomerCoachmarkShown'
      )
      if (isComingFromTryDemoSell && !isAddCustomerCoachmarkShown) {
        value?.start()
      }
      return () => {
        value?.stop()
      }
    }, [isLayoutRendered])
  )

  useEffect(() => {
    value?.copilotEvents.on('stop', () => {
      storageUtil.saveObject('addCustomerCoachmarkShown', true)
      publishEvent('click_action', {
        item_name: 'product_selection_coachmark',
      })
    })
  }, [value?.copilotEvents])

  return {
    CopilotStack,
    CopilotProvider,
    CopilotStep,
    customerAdditionSource,
    isComingFromTryDemoSell,
    isLayoutRendered,
    setIsLayoutRendered,
  }
}

export { useCoachMarks }
